import { Getter, GetterTree } from "vuex";
import { RootState } from "@/store/RootState";
import { BuffetGetter, BuffetState } from "@/components/buffet/types";

export const getters: GetterTree<BuffetState, RootState> &
  Record<BuffetGetter, Getter<BuffetState, RootState>> = {
  [BuffetGetter.getUpdatedBuffetItems](state) {
    return state.updatedBuffetItems;
  },
  [BuffetGetter.getPlayedEpgItemPos](state) {
    return state.playedEpgItemPos;
  },
  [BuffetGetter.getPlayedEpgItemId](state) {
    return state.playedEpgItemId;
  },
  [BuffetGetter.getPlayedEpgItemCat](state) {
    return state.playedEpgItemCat;
  },
  [BuffetGetter.getPlayedEpgItemDate](state) {
    return state.playedEpgItemDate;
  }
};
